import { object, string, boolean } from 'yup';

export default object().shape({
  nome: string().required('Este campo é obrigatório!'),
  email: string().email('E-mail inválido').required('Este campo é obrigatório!'),
  cpf: string().required('Este campo é obrigatório!'),
  ativo: boolean(),
})

